import { ActionTree } from 'vuex'
import { RootState } from '@/store/types'
import StoreAPI from '@/util/api/StoreAPI'
import { main } from '@/main'
import { FETCH_UPDATES } from '@/store/entries/constants'
import Entry from '@/data/entry-model'
import {
    EDITOR_SET_ERRORS,
    EDITOR_MARK_SYNCING,
    EDITOR_MARK_SYNCED,
    EDITOR_RESET_STATUSES,
    EDITOR_SET_DATA,
    ENTRY_UPDATE_MODEL
} from '@/store/editor/constants'
import {
    REVISION_LOAD,
    REVISION_ADD,
    REVISION_NEW_SET,
    REVISION_LOAD_INITIAL,
    REVISION_LOAD_MORE,
    REVISION_RESTORE
} from './constants'
import { RevisionState } from './types'

const actions: ActionTree<RevisionState, RootState> = {
    async [REVISION_LOAD](
        { state, commit, rootState },
        { offset, limit }: { offset: number, limit: number }
    ): Promise<void> {
        const { entry } = rootState.editor
        if (state.tracking !== entry.id) {
            commit(REVISION_NEW_SET, entry.id)
        }
        commit(REVISION_ADD, await StoreAPI.revisions(entry.id!, entry.documentKey!, offset, limit))
    },

    async [REVISION_LOAD_INITIAL]({ dispatch }): Promise<void> {
        dispatch(REVISION_LOAD, { offset: 0, limit: 5 })
    },

    async [REVISION_LOAD_MORE]({ dispatch, state }): Promise<void> {
        dispatch(REVISION_LOAD, { offset: state.revisions.length, limit: 5 })
    },

    async [REVISION_RESTORE]({ dispatch, commit, getters }): Promise<void> {
        if (getters.hasErrors) {
            commit(EDITOR_SET_ERRORS, getters.entryErrors)
            main.$error({ text: 'Validation error when attempting to sync entry' })
            main.$error({
                text: JSON.stringify(getters.entryErrors)
            })
            return
        }
        commit(EDITOR_MARK_SYNCING)
        try {
            const model: Entry = await dispatch(ENTRY_UPDATE_MODEL)
            model.save()
            commit(EDITOR_MARK_SYNCED)
            commit(EDITOR_SET_DATA, model)
            dispatch(FETCH_UPDATES)
            dispatch(REVISION_LOAD_INITIAL)
            main.$info({ text: 'Entry synced' })
        } catch (err) {
            console.error(err)
            main.$error({ text: err })
        }
        setTimeout(() => commit(EDITOR_RESET_STATUSES), 2000)
    }
}

export default actions
